<template>
  <div class="box">
    <Header title="价格查询"></Header>
    <div class="show-box">
      <div class="title-card"></div>
      <div class="info-detail-box">
        <div class="detail-title">零件详情</div>
        <div class="detail-line2">
          <div class="detail-line">
            <div class="detail-line-title">零件号</div>
            <div class="detail-line-content" v-text="partNo"></div>
          </div>
          <div class="detail-icon">
            <img class="icon-img" src="../assets/images/partInquriyDetail-1.png" alt />
          </div>
        </div>
        <div class="detail-line2">
          <div class="detail-line">
            <div class="detail-line-title">销售状态</div>
            <div class="detail-line-content-1" v-if="sccFlg" v-text="scc"></div>
            <div class="detail-line-content-2" v-else v-text="scc"></div>
          </div>
          <div class="detail-line-right">
            <div class="detail-line-title">零件状态</div>
            <div class="detail-line-content-1" v-if="statusFlg">Active</div>
            <div class="detail-line-content-2" v-else>Inactive</div>
          </div>
        </div>
        <div class="detail-line2">
          <div class="detail-line">
            <div class="detail-line-title">零件号(曾用)</div>
            <div class="detail-line-content" v-text="movexNo"></div>
          </div>
          <div class="detail-line-right">
            <div class="detail-line-title">产品组</div>
            <div class="detail-line-content" v-text="partGroup"></div>
          </div>
        </div>
        <div class="detail-line2">
          <div class="detail-line">
            <div class="detail-line-title">最小起订量(MOQ)</div>
            <div class="detail-line-content" v-text="moq"></div>
          </div>
          <div class="detail-line-right">
            <div class="detail-line-title">替代件</div>
            <div class="detail-line-content" v-text="supersedingPartNo"></div>
          </div>
        </div>
        <div class="detail-line2">
          <div class="detail-line">
            <div class="detail-line-title">零件名称</div>
            <div class="detail-line-content" v-text="desc"></div>
          </div>
          <div class="detail-line-right">
            <div class="detail-line-title">中文名称</div>
            <div class="detail-line-content" v-text="descCn"></div>
          </div>
        </div>
        <van-collapse v-model="activeNames">
          <van-collapse-item>
            <div class="detail-line2">
              <div class="detail-line">
                <div class="detail-line-title">平均月消耗量</div>
                <div class="detail-line-content" v-text="avgMonthlyUsage"></div>
              </div>
              <div class="detail-line-right">
                <div class="detail-line-title">源工厂</div>
                <div class="detail-line-content" v-text="sourcePlant"></div>
              </div>
            </div>
            <div class="detail-line2">
              <div class="detail-line">
                <div class="detail-line-title">定制件库存件区分</div>
                <div class="detail-line-content" v-text="maketoFlag"></div>
              </div>
              <div class="detail-line-right">
                <div class="detail-line-title">零件类型</div>
                <div class="detail-line-content" v-text="goodsCategoryid"></div>
              </div>
            </div>
            <div class="detail-line2">
              <div class="detail-line">
                <div class="detail-line-title">零件简称</div>
                <div class="detail-line-content" v-text="shortDescription"></div>
              </div>
              <div class="detail-line-right">
                <div class="detail-line-title">材质</div>
                <div class="detail-line-content" v-text="materialQuality"></div>
              </div>
            </div>
            <div class="detail-line2">
              <div class="detail-line">
                <div class="detail-line-title">长*宽*高(cm^3)</div>
                <div
                  class="detail-line-content"
                  v-text="partLength + '*' + partWidth + '*' + partHeight"
                ></div>
              </div>
              <div class="detail-line-right">
                <div class="detail-line-title">重量KG</div>
                <div class="detail-line-content" v-text="goodsWeight"></div>
              </div>
            </div>
            <div class="detail-line2">
              <div class="detail-line">
                <div class="detail-line-title">短零件号</div>
                <div class="detail-line-content" v-text="printPartNo"></div>
              </div>
              <div class="detail-line-right">
                <div class="detail-line-title">安全属性</div>
                <div class="detail-line-content" v-text="hazardouspartFlag"></div>
              </div>
            </div>
            <div class="detail-line2">
              <div class="detail-line">
                <div class="detail-line-title">产品组描述</div>
                <div class="detail-line-content" v-text="productGroupDesc"></div>
              </div>
              <div class="detail-line-right">
                <div class="detail-line-title">PvcCode</div>
                <div class="detail-line-content" v-text="pvcCode"></div>
              </div>
            </div>
            <div class="detail-line2">
              <div class="detail-line">
                <div class="detail-line-title">牌价(含税)</div>
                <div class="detail-line-content" v-text="fixedPrice"></div>
              </div>
              <div class="detail-line-right">
                <div class="detail-line-title">牌价状态</div>
                <div class="detail-line-content" v-text="priceStatus"></div>
              </div>
            </div>
            <div class="detail-line2">
              <div class="detail-line">
                <div class="detail-line-title">地区号</div>
                <div class="detail-line-content" v-text="regionCode"></div>
              </div>
              <div class="detail-line-right">
                <div class="detail-line-title">币种</div>
                <div class="detail-line-content" v-text="currencyCode"></div>
              </div>
            </div>
            <div class="detail-line2">
              <div class="detail-line">
                <div class="detail-line-title">再制造D零件号</div>
                <div class="detail-line-content" v-text="dpartPartno"></div>
              </div>
              <div class="detail-line-right">
                <div class="detail-line-title">再制造C零件号</div>
                <div class="detail-line-content" v-text="cpartPartno"></div>
              </div>
            </div>
            <div class="detail-line2">
              <div class="detail-line">
                <div class="detail-line-title">零件分类</div>
                <div class="detail-line-content" v-text="partClassify"></div>
              </div>
              <div class="detail-line-right">
                <div class="detail-line-title">二级分类</div>
                <div class="detail-line-content" v-text="partSubClassify"></div>
              </div>
            </div>
            <div class="detail-line2">
              <div class="detail-line">
                <div class="detail-line-title">零件长描述</div>
                <div class="detail-line-content" v-text="partDesc"></div>
              </div>
              <div class="detail-line-right">
                <div class="detail-line-title">适用机型和应用</div>
                <div class="detail-line-content" v-text="fitModels"></div>
              </div>
            </div>
            <div class="detail-line2">
              <div class="detail-line">
                <div class="detail-line-title">发动机生产商</div>
                <div class="detail-line-content" v-text="engineProducer"></div>
              </div>
              <div class="detail-line-right">
                <div class="detail-line-title">排放标准</div>
                <div class="detail-line-content" v-text="emissionStandard"></div>
              </div>
            </div>
            <div class="detail-line2">
              <div class="detail-line">
                <div class="detail-line-title">发动机机型</div>
                <div class="detail-line-content" v-text="engineType"></div>
              </div>
              <div class="detail-line-right">
                <div class="detail-line-title">包装规格</div>
                <div class="detail-line-content" v-text="specification"></div>
              </div>
            </div>
            <div class="detail-line2">
              <div class="detail-line">
                <div class="detail-line-title">产地</div>
                <div class="detail-line-content" v-text="originPlace"></div>
              </div>
              <div class="detail-line-right">
                <div class="detail-line-title">适用市场</div>
                <div class="detail-line-content" v-text="fitMarket"></div>
              </div>
            </div>
            <div class="detail-line2">
              <div class="detail-line">
                <div class="detail-line-title">供应商</div>
                <div class="detail-line-content" v-text="provider"></div>
              </div>
              <div class="detail-line-right">
                <div class="detail-line-title">升数</div>
                <div class="detail-line-content" v-text="increment"></div>
              </div>
            </div>
            <div class="detail-line2">
              <div class="detail-line">
                <div class="detail-line-title">质量等级</div>
                <div class="detail-line-content" v-text="qualityGrade"></div>
              </div>
              <div class="detail-line-right">
                <div class="detail-line-title">粘度等级</div>
                <div class="detail-line-content" v-text="viscosityGrade"></div>
              </div>
            </div>
            <div class="detail-line2">
              <div class="detail-line">
                <div class="detail-line-title">包装零件号</div>
                <div class="detail-line-content" v-text="packingPartNo"></div>
              </div>
            </div>
            <div class="detail-line3"></div>
          </van-collapse-item>
        </van-collapse>
      </div>
      <div class="inquriy-list-box">
      <div class="inquriy-center">
            <van-search
              class="top-search"
              v-model="qty"
              shape="round"
              clearable
              left-icon
              placeholder="请输入零件数量"
              background="none"
              @search="searchHandle"
              @blur="getInputCount(qty,moq)"
            />
          </div>
        <div class="inquriy-right">
          <img
            class="right-img"
            src="../assets/images/search.png"
            alt
            @click="searchHandle"
          />
        </div>
      </div>
      <div class="detail-line3"></div>
      <div class="info-detail-box" style="padding-bottom: 30px;" >
        <div class="detail-title" style="width: 85%;">价格信息</div>
        <div class="detail-line2">
          <div class="detail-line">
            <div class="detail-line-title">牌价(含税)</div>
            <div class="detail-line-content" v-text="fixedPrice"></div>
          </div>
          <div class="detail-line-right">
                <div class="detail-line-title">牌价状态</div>
                <div class="detail-line-content" v-text="priceStatus"></div>
              </div>
        </div>
        <div class="detail-line2">
          <div class="detail-line">
            <div class="detail-line-title">折扣价(含税)</div>
            <div class="detail-line-content" v-text="unitPrice"></div>
          </div>
          <div class="detail-line-right">
            <div class="detail-line-title">折扣率</div>
            <div class="detail-line-content" v-text="discountRate"></div>
          </div>
        </div>
        <div class="detail-line2">
          <div class="detail-line">
            <div class="detail-line-title">是否阶梯价格</div>
            <div class="detail-line-content" v-text="ladderPriceFlag"></div>
          </div>
          <div class="detail-line-right">
            <div class="detail-line-title">第一阶梯数量</div>
            <div class="detail-line-content" v-text="ladderPriceQty"></div>
          </div>
        </div>
        <div class="detail-line2">
          <div class="detail-line">
            <div class="detail-line-title">Core零件号</div>
            <div class="detail-line-content" v-text="corePartNo"></div>
          </div>
          <div class="detail-line-right">
            <div class="detail-line-title">Core含税价格</div>
            <div class="detail-line-content" v-text="corePrice"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getGoodsDetail, getGoodsInquriy } from "@/api/priceSearchDetail";
import { STATUS_CODE_OK } from "@/config";
import store from "@/store";
import Header from "@/components/Header";
export default {
  name: "priceSearchDetail",
  data() {
    return {
      //主要显示的项目
      partNo: "", //零件号
      scc: "", //销售状态
      status: "", //零件状态
      movexNo: "", //零件号(曾用）
      partGroup: "", //产品组
      moq: "", //最小起订量（MOQ）
      supersedingPartNo: "", //替代件
      desc: "", //零件名称
      descCn: "", //中文名称

      //零件价格显示项目
      qty: "", //零件数量
      dealerId: "", //经销商ID
      memberId: "", //member号
      unitPrice: "", //折扣价(含税)
      discountRate: "", //折扣率(含税)
      ladderPriceFlag: "", //是否阶梯价格
      ladderPriceQty: "", //第一阶梯数量
      corePartNo: "", //Core零件号
      corePrice: "", //Core含税价格

      //收缩显示的项目
      avgMonthlyUsage: "", //平均月消耗量
      sourcePlant: "", //源工厂
      maketoFlag: "", //定制件库存件区分
      goodsCategoryid: "", //零件类型
      shortDescription: "", //零件简称
      goodsWeight: "", //重量KG
      partLength: "", //长CM
      partWidth: "", //宽CM
      partHeight: "", //高CM
      printPartNo: "", //短零件号
      hazardouspartFlag: "", //安全属性
      productGroupDesc: "", //产品组描述
      pvcCode: "", //PVC code
      fixedPrice: "", //牌价（含税）
      priceStatus: "", //牌价状态
      regionCode: "", //地区号
      currencyCode: "", //币种
      dpartPartno: "", //再制造D零件号
      cpartPartno: "", //再制造C零件号
      partClassify: "", //零件分类
      partSubClassify: "", //二级分类
      partDesc: "", //零件长描述
      fitModels: "", //适用机型和应用
      engineProducer: "", //发动机生产商
      emissionStandard: "", //排放标准
      engineType: "", //发动机机型
      specification: "", //包装规格
      originPlace: "", //产地
      fitMarket: "", //适用市场
      provider: "", //供应商
      increment: "", //升数
      qualityGrade: "", //质量等级
      viscosityGrade: "", //粘度等级
      packingPartNo: "", //包装零件号
      materialQuality: "", //材质
      activeNames: ["0"],
      sccFlg: false,
      statusFlg: false,
      userCode: "",
      inventioryCharty1: [],
      inventioryCharty2: [],
      inventioryChartx: [],
      inventioryWarehouse: [],
      chartLoadingShow: false,
      reloadTime: 0,
      reTryInfoShow: false,
      priceShowFlg: false
    };
  },
  mounted() {
    // 获取零件详情信息
    this.getGoodsDetailInfo();
  },
  methods: {
    async getGoodsDetailInfo() {
      this.partNo = store.getters.partNo;
      let { data } = await getGoodsDetail({
        id: this.partNo, //零件号
      });
      if (data.resultStatusCode === STATUS_CODE_OK) {
        //主要显示的项目
        this.scc = data.goodsVo.currentSalesStatusCode; //销售状态
        if (
          this.scc === "70" ||
          this.scc === "71" ||
          this.scc === "91" ||
          this.scc === "94"
        ) {
          this.sccFlg = true;
        } else {
          this.sccFlg = false;
        }
        //零件状态
        this.status = data.goodsVo.partStatus; //零件状态
        if (this.status === "A") {
          this.statusFlg = true;
        } else {
          this.statusFlg = false;
        }
        this.movexNo = data.goodsVo.movexno; //零件号(曾用）
        this.partGroup = data.goodsVo.productGroup; //产品组
        this.moq = data.goodsVo.productBigPackage; //最小起订量（MOQ）
        this.qty = data.goodsVo.productBigPackage; //最小起订量（MOQ）
        if (data.goodsVo.supersedingPartInfo) {
          for (var i = 0; i < data.goodsVo.supersedingPartInfo.length; i++) {
            if (i === 0) {
              this.supersedingPartNo =
                data.goodsVo.supersedingPartInfo[i].supersedingPartNo;
            } else {
              this.supersedingPartNo =
                this.supersedingPartNo +
                "," +
                data.goodsVo.supersedingPartInfo[i].supersedingPartNo;
            }
          }
        } //替代件
        this.desc = data.goodsVo.name; //零件名称
        this.descCn = data.goodsVo.catalogDesc; //中文名称
        //收缩显示的项目
        this.avgMonthlyUsage = data.goodsVo.avgMonthlyUsage; //平均月消耗量
        this.sourcePlant = data.goodsVo.sourcePlant; //源工厂
        this.maketoFlag = data.goodsVo.maketoFlag; //定制件库存件区分
        this.goodsCategoryid = data.goodsVo.goodsCategoryid; //零件类型
        this.shortDescription = data.goodsVo.shortDescription; //零件简称
        this.saleStatus = data.goodsVo.saleStatus; //销售状态排序
        this.partLength = data.goodsVo.partLength; //长CM
        this.partWidth = data.goodsVo.partWidth; //宽CM
        this.partHeight = data.goodsVo.partHeight; //高CM
        this.goodsWeight = data.goodsVo.goodsWeight; //重量KG
        this.printPartNo = data.goodsVo.printPartNo; //短零件号
        this.hazardouspartFlag = data.goodsVo.hazardouspartFlag; //安全属性
        this.productGroupDesc = data.goodsVo.productGroupDesc; //产品组描述
        this.pvcCode = data.goodsVo.pvcCode; //PVC code
        this.fixedPrice = data.goodsVo.fixedPrice; //牌价（含税）
        if (data.goodsVo.priceStatus && (data.goodsVo.priceStatus == "Y" || data.goodsVo.priceStatus == "y")) {
          this.priceStatus = "有效"
        } else {
          this.priceStatus = "无效"
        } //牌价状态
        this.regionCode = data.goodsVo.regionCode; //地区号
        this.currencyCode = data.goodsVo.currencyCode; //币种
        this.dpartPartno = data.goodsVo.dpartPartno; //再制造D零件号
        this.cpartPartno = data.goodsVo.cpartPartno; //再制造C零件号
        this.partClassify = data.goodsVo.partClassifyName; //零件分类
        this.partSubClassify = data.goodsVo.partSubClassify; //二级分类
        this.partDesc = data.goodsVo.partDesc; //零件长描述
        this.fitModels = data.goodsVo.fitModels; //适用机型和应用
        this.engineProducer = data.goodsVo.engineProducer; //发动机生产商
        this.emissionStandard = data.goodsVo.emissionStandard; //排放标准
        this.engineType = data.goodsVo.engineType; //发动机机型
        this.specification = data.goodsVo.specification; //包装规格
        this.originPlace = data.goodsVo.originPlace; //产地
        this.fitMarket = data.goodsVo.fitMarket; //适用市场
        this.provider = data.goodsVo.provider; //供应商
        this.increment = data.goodsVo.increment; //升数
        this.qualityGrade = data.goodsVo.qualityGrade; //质量等级
        this.viscosityGrade = data.goodsVo.viscosityGrade; //粘度等级
        this.packingPartNo = data.goodsVo.packingPartNo; //包装零件号
        this.materialQuality = data.goodsVo.materialQuality; //材质
        this.searchHandle();
      }
    },
    // 查询零件价格数据
    async searchHandle() {
      // this.setSearchContent(this.moq);
      this.finished = false;
      this.inquriyList = [];
      this.pageNo = 1;
      this.dealerId = localStorage.getItem('dealerId');
      this.memberId = localStorage.getItem('memberId');
      let { data } = await getGoodsInquriy({
        qty: this.qty,
        gomsId: this.dealerId,
        partNo: this.partNo,
        listPrice: this.fixedPrice,
        memberId: this.memberId
      });
      if (data.resultStatusCode === STATUS_CODE_OK) {
        if (data.priceQueryBean.unitPrice == null || data.priceQueryBean.unitPrice == "") {
          this.unitPrice = "-";
        } else {
          this.unitPrice = data.priceQueryBean.unitPrice;
        }
        if (data.priceQueryBean.discountRate == null || data.priceQueryBean.discountRate == "") {
          this.discountRate = "-";
        } else {
          this.discountRate = data.priceQueryBean.discountRate;
        }
        if (data.priceQueryBean.ladderPriceFlag == "N") {
          this.ladderPriceFlag = "否";
          this.ladderPriceQty = "-";
        } else if (data.priceQueryBean.ladderPriceFlag == "Y") {
          this.ladderPriceFlag = "是";
          this.ladderPriceQty = data.priceQueryBean.ladderPriceQty;
        }
        if (data.priceQueryBean.corePartNo == null || data.priceQueryBean.corePartNo == "") {
          this.corePartNo = "-";
        } else {
          this.corePartNo = data.priceQueryBean.corePartNo;
        }
        if (data.priceQueryBean.corePrice == null || data.priceQueryBean.corePrice == "") {
          this.corePrice = "-";
        } else {
          this.corePrice = data.priceQueryBean.corePrice;
        }
      }
    },
    isBlank(param) {
     if (
       !param ||
       param == null ||
       param == '' ||
       param == 'null' ||
       param == 'undefined' ||
       param.length < 1
     ) {
       return true;
     }
     return false;
    },
    /*
    * 数量与最小包装量联动
    */ 
    getInputCount(inputCount, productBigPackage){
      if (!this.checkNum(inputCount)) {
        inputCount = 1;
      }
      productBigPackage = this.isBlank(productBigPackage) ? 1 : parseInt(productBigPackage);
      inputCount = this.isBlank(inputCount) ? 0 : parseInt(inputCount);
      let aliquot = 0;
      let retInputCount = 0
      if (productBigPackage == 1) {
        inputCount = inputCount == 0 ? 1 : inputCount;
        retInputCount = inputCount;
      } else {
            // 向上取整
            inputCount = inputCount == 0 ? 1 : inputCount;
            aliquot = Math.ceil(inputCount / productBigPackage);
        retInputCount =  productBigPackage * aliquot;
        
      }
      if (retInputCount > 9999) {
        retInputCount = retInputCount - productBigPackage
      }
      this.qty = retInputCount;
      return this.qty;
    },
  
  /**
   * 判断是否是数字
   **/
    checkNum(value) {
      let reg = new RegExp('^[0-9]*$');
      if (!reg.test(value) || this.isBlank(value)) {
        return false;
      } else {
        return true;
      }
    },
  },
  components: {
    Header,
  },
};
</script>
<style lang="scss" scoped>
.box {
  height: 100%;
  .info-detail-box {
    width: 100%;
    border-radius: 20px;
    padding: 0px 20px;
    margin-top: 20px;
    .detail-title {
      width: 45%;
      text-align: left;
      border-bottom: 1px solid #dcdcdc;
      font-size: 14px;
      font-weight: bold;
      color: #000000;
      padding: 15px 0px 5px 0px;
    }
    .detail-line2 {
      display: flex;
      .detail-line {
        padding: 10px 10px 0px 0px;
        text-align: left;
        width: 50%;
      }
      .detail-line-right {
        padding: 10px 0px 0px 20px;
        text-align: left;
        width: 50%;
      }

      .detail-line-title {
        color: #999999;
        font-size: 12px;
        padding-bottom: 2px;
      }
      .detail-line-content {
        min-height: 18px;
        font-size: 12px;
        color: #000000;
        padding-right: 10px;
        -webkit-box-orient: vertical;
        word-wrap: break-word;
      }
      .detail-icon {
        position: absolute;
        right: 15px;
        top: 0px;
        .icon-img {
          width: 130px;
        }
      }
      .detail-line-content-1 {
        min-height: 18px;
        font-size: 12px;
        color: green;
        padding-right: 10px;
      }
      .detail-line-content-2 {
        min-height: 18px;
        font-size: 12px;
        color: #da291c;
        padding-right: 10px;
      }
    }
  }
  .inquriy-list-box {
    position: static;
    margin-top: 20px;
    .inquriy-center {
      float: left;
      margin-left: 15px;
      padding: 0px 10px 0px 0px;
      width: 80%;
      .top-search {
        padding: 0px;
        .van-cell {
          padding: 0px 10px 0px 0px;
        }
        /deep/ .van-field__control {
          padding: 0px 15px;
        }
      }
    }
    .inquriy-right{
      float: left;
      margin-top: -14px;
      .right-img {
        width: 50px;
        height: 50px;
      }
    }
  }
  .detail-line3 {
    padding-bottom: 20px;
  }
}
</style>